import { render, staticRenderFns } from "./ChurchManagePage.vue?vue&type=template&id=7002398a&scoped=true&"
import script from "./ChurchManagePage.vue?vue&type=script&lang=js&"
export * from "./ChurchManagePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7002398a",
  null
  
)

export default component.exports